import { createApp } from 'vue'
import store from 'store'

import CheckoutCartButtons from './CheckoutCartButtons.vue'

const el = 'checkout-cart-buttons'
const DOM = document.querySelector(el)

const render = function() {
    if (DOM) {
        const app = createApp(CheckoutCartButtons, {
            dataShoppingUrl: DOM.getAttribute('data-shopping-url'),
            continueShoppingLabel: DOM.getAttribute('data-continue-shopping-label'),
            checkOutPageUrl: DOM.getAttribute('data-checkout-url'),
            checkOutButtonText: DOM.getAttribute('data-checkout-button-text')
        })
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}

